<script>
    import { onMount, onDestroy } from "svelte";
    import { page, modal } from '../store/nav';
    import { Datepicker } from 'svelte-calendar';
    import { formatDate } from "../js/helper";
    import Icon from "../components/icon.svelte";

    import { recurring } from "../store/recurring";
    import { items } from "../store/items";
    import { categories } from "../store/categories";

    import { idb } from "../db"

    import AutoComplete from "simple-svelte-autocomplete"

    import { createId } from "../js/helper";

    export let item_uid;
    export let selected_date;
    let category = {
        "options": ["organic"],
        "flavors": [],
        "cuts": []
    };

    let selectedDate =  new Date(parseInt(selected_date));

    onMount(async ()=>{
        const item = await $recurring.find( i => i.uid == item_uid);
        category = $categories[item.category];
    });

    const theme = {
        "calendar": {
            "width": "100vw",
            "maxWidth": "100vw",
            "legend": {
            "height": "45px"
            },
            "shadow": "0px 10px 26px rgba(0, 0, 0, 0.25)",
            "colors": {
            "text": {
                "primary": "#222531",
                "highlight": "#FFF"
            },
            "background": {
                "primary": "#fff",
                "highlight": "#ccee3e",
                "hover": "#ccee3e"
            },
            "border": "#eee"
            },
            "font": {
            "regular": "1.5em",
            "large": "20em"
            },
            "grid": {
            "disabledOpacity": ".35",
            "outsiderOpacity": ".6"
            }
        }
    };

    const deleteRecurringItem = async i => {
        console.log(`RECURRING Delete link for item in list`, i);
        modal.close();
        recurring.delete(i.uid);
        await items.init(i.itemInList);
        if ( i.itemInList ) {
            await items.editSingleField(i.itemInList, `recurring`, false);
            await items.editSingleField(i.itemInList, `recurringUid`, ``);
            idb.save(`pc_items`, $items);
        }
    }

    $:selectedDate,recurring.editSingleField(item_uid,`next`, Date.parse(selectedDate));
    onDestroy(() => {
        //idb.save(`pc_recurring`,[recurring.find( r => r.uid == item_uid)])
        console.log($items);
    });
</script>
<section >
    {#each $recurring as item}
    {#if item.uid == item_uid}
        <div class="bg-primary absolute rounded-2xl w-12 h-12 shrink-0 top-5 right-5">
            <img class="m-auto w-8 h-8 mt-2" src="/img/icon/food/{item.category}.png" alt="">
        </div>

        <section class="text-primary flex flex-col space-y-2">
            <span class="text-2xl ">{item.name}</span>
            <section class="flex space-x-1">
                <span>Qty: </span>
                <input class="ml-1.5 border-b border-shade w-16 text-center" type="text" name="" id="" bind:value={item.qty}>
                <div on:click|stopPropagation={()=>{if((item.qty-1) >= 0) {item.qty--}else{item.qty=0}}}>
                    <Icon class="w-4 place-self-center" name="minus-insquare-dark"/>
                </div>
                <div on:click|stopPropagation={()=>item.qty++}>
                    <Icon class="w-4 place-self-center" name="plus-insquare-dark"/>
                </div>
                
            </section>
            <section class="flex space-x-2.5">
                <span>Unit: </span>
                <select class="border border-shade px-2 rounded-sm w-24 capitalize text-sm italic place-self-center" id="unit" bind:value={item.unit}>
                    <option value="lbs">lbs</option>
                    <option value="oz">oz</option>
                    <option value="gal">Gallon</option>
                    <option value="qt">Quart</option>
                    <option value="pt">Pint</option>
                    <option value="bag">Bag</option>
                    <option value="bunch">Bunch</option>
                    <option value="">Unit</option>
                </select>
            </section>
            {#if category.cuts.length > 0 }
                <section class="flex space-x-2.5">
                    <span>Cut: </span>
                    <AutoComplete className="capitalize text-primary " inputClassName="capitalize border border-shade text-primary text-ellipsis overflow-hidden" hideArrow={true} items="{category.cuts}" bind:selectedItem="{item.cut}" />
                </section>
            {/if}
            <section class="flex space-x-2.5 flex-wrap">
                {#each item.options as dietOption }
                    {#each Object.entries(dietOption) as [dietKey, dietValue] }
                        <span class:selected={dietOption[dietKey]} class="border border-shade mt-1.5 px-2 rounded-sm  min-w-16 capitalize text-sm italic place-self-center" on:click={()=>{if(dietOption[dietKey]){dietOption[dietKey]=false}else{dietOption[dietKey]=true}}}>{dietKey}</span>
                    {/each}                
                {/each}
            </section>
            <section class="flex">
                <span>Details: </span>
                <input class="ml-2.5 border-b border-shade min-w-16" type="select" name="" id="" bind:value={item.details}>
            </section>
            <span>----------</span>
            <span class="">Frequency</span>
            <section class="flex space-x-2">
                <span class:selected={item.frequency==`weekly`} class="border border-shade p-2 rounded-sm capitalize text-sm italic" on:click={()=>{item.frequency=`weekly`;}}>weekly</span>
                <span class:selected={item.frequency==`other w`} class="border border-shade p-2 rounded-sm capitalize text-sm italic" on:click={()=>{item.frequency=`other w`;}}>other w</span>
                <span class:selected={item.frequency==`monthly`} class="border border-shade p-2 rounded-sm capitalize text-sm italic" on:click={()=>{item.frequency=`monthly`;}}>monthly</span>
                <span class:selected={item.frequency==`quaterly`} class="border border-shade p-2 rounded-sm capitalize text-sm italic" on:click={()=>{item.frequency=`quaterly`;}}>quaterly</span>
            </section>
            <span>Pick next date:</span>
            <section >
                <Datepicker bind:selected={selectedDate} let:key let:send let:receive {theme}>
                    <button class="border border-shade p-2 rounded-sm capitalize text-sm italic" in:receive|local={{ key }} out:send|local={{ key }} >
                        {formatDate.md(selectedDate)}
                    </button>
                </Datepicker>
            </section>
            <section class="self-end text-shade italic text-sm" on:click={()=>deleteRecurringItem(item)}>
                Delete
            </section>
        </section>
    {/if}
    {/each}
</section>
<style lang="postcss">
    .selected {
        @apply border-secondary text-secondary bg-primary;
    }
</style>